module.exports = __webpack_public_path__ + "static/media/logo2.ed928e11.png";